<template>
  <div id="UserManagement" v-if="userinfo.isAdmin">
    <h1 class="mt-4" style="margin-bottom: 40px">User Management</h1>
    <b-container>
      <b-row align-h="end">
        <b-col cols="2">
          <b-button variant="primary" @click="exportUser()"
            >Export Users</b-button
          >
        </b-col>
      </b-row>
      <b-form class="text-left mt-3 " style="margin-bottom: 20px; text-align: right">
        <b-input-group size="" class="mb-2">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            type="search"
            v-model="filter"
            placeholder="Search User"
          ></b-form-input>
        </b-input-group>
      </b-form>
      <b-table
        :fields="fields"
        :items="items"
        hover
        outlined
        :sort-by.sync="sortBy"
        :filter="filter"
      >
        <template #cell(isActive)="data">
          <!--
          <b-button size="sm" variant="primary" :href="`#/problem/${data.item.id}`">{{ data.value }}</b-button>
          -->
          <p class="h4 mb-2">
            <b-icon
              v-if="data.item.isActive"
              icon="check-circle"
              variant="success"
            ></b-icon>
            <b-icon v-else icon="x-circle" variant="danger"></b-icon>
          </p>
        </template>
        <template #cell(isAdmin)="data">
          <!--
          <b-button size="sm" variant="primary" :href="`#/problem/${data.item.id}`">{{ data.value }}</b-button>
          -->
          <p class="h4 mb-2">
            <b-icon
              v-if="data.item.isAdmin"
              icon="check-circle"
              variant="success"
            ></b-icon>
            <b-icon v-else icon="x-circle" variant="danger"></b-icon>
          </p>
        </template>
        <template #cell(action)="data">
          <!--
          <b-button size="sm" variant="primary" :href="`#/problem/${data.item.id}`">{{ data.value }}</b-button>
          -->
          <b-button size="sm" variant="primary" @click="editUser(data.item)"
            >Edit</b-button
          >
          <!--
          <b-button
            size="sm"
            variant="danger"
            @click="
              problem_title = data.item.title;
              problem_id = data.item.id;
              checkDeleteUser(items.indexOf(data.item));
            "
            :disabled="data.item.username == userinfo.username"
            style="margin-left: 10px"
            >Delete</b-button
          >-->
        </template>
      </b-table>
      <b-modal
        ref="edit_user"
        id="edit_user"
        hide-footer
        title="Edit"
        size="xl"
      >
        <b-form inline style="margin-bottom: 10px; margin-left: 20px">
          <div class="form-row" style="margin-bottom: 10px; text-align: center">
            <label class="mr-3">User Name</label>
            <b-form-input
              class="mr-3"
              type="text"
              disabled
              :value="edit_username"
            ></b-form-input>
            <label class="mr-3">E-mail</label>
            <b-form-input
              class="mr-3"
              type="text"
              id="email"
              disabled
              :value="edit_email"
            ></b-form-input>
            <b-form-checkbox
              class="mr-3"
              id="checkbox-1"
              v-model="edit_isActive"
              name="checkbox-1"
              switch
              style="margin-top: 8px"
              :disabled="editSelf"
            >
              Is Active?
            </b-form-checkbox>
            <b-form-checkbox
              class="mr-3"
              id="checkbox-2"
              v-model="edit_isAdmin"
              name="checkbox-2"
              switch
              style="margin-top: 8px"
              :disabled="editSelf"
            >
              Is Admin?
            </b-form-checkbox>
            <b-button
              size="sm"
              class="mr-3"
              variant="primary"
              @click="updateUser"
              >Update</b-button
            >
          </div>
        </b-form>
        <div class="col text-center"></div>
      </b-modal>
      <b-modal ref="warning" id="warning" hide-footer title="Warning">
        <div class="text-center" style="font-size: 1.2rem">
          <p>
            This action will delete user "{{ problem_title }}" and all
            checkpoints of this problem!
          </p>
          <p>Are You Sure?</p>
        </div>
        <div class="col text-center">
          <b-button class="mt-3" variant="primary" @click="hideWarning"
            >No!</b-button
          >
          <b-button class="mt-3" variant="danger" style="margin-left: 10px"
            >Delete!</b-button
          >
        </div>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
export default {
  created() {
    this.get_user_info();
    this.get_user_list();
  },
  beforeMount() {
    let self = this;
    this.$bus.$on("isAdmin", (event) => {
      self.is_admin = event.is_admin;
    });
  },
  mounted() {},
  beforeDestroy() {
    this.$bus.$off("isAdmin");
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: false,
        },
        {
          key: "username",
        },
        {
          key: "email",
          label: "E-mail",
        },
        {
          key: "isActive",
          label: "Active",
        },
        {
          key: "isAdmin",
          label: "Admin",
        },
        {
          key: "action",
        },
      ],
      items: [],
      sortBy: "id",
      is_admin: undefined,
      probelm_id: undefined,
      problem_title: "",
      origin_problems_num: 0,
      userinfo: {
        isAdmin: false,
        isActive: false,
      },
      edit_username: undefined,
      edit_user_id: undefined,
      edit_email: undefined,
      edit_isActive: false,
      edit_isAdmin: false,
      editSelf: false,
      filter: "",
    };
  },
  methods: {
    toProblem(problem_id) {
      let self = this;
      this.$router.push({
        name: "Problem",
        params: {
          id: problem_id,
          userinfo: self.userinfo,
        },
      });
    },
    editUser(user) {
      let self = this;
      this.edit_user_id = user.id;
      this.edit_username = user.username;
      this.edit_email = user.email;
      this.edit_isActive = user.isActive;
      this.edit_isAdmin = user.isAdmin;
      if (user.username == this.userinfo.username) {
        this.editSelf = true;
      } else {
        this.editSelf = false;
      }
      self.$refs["edit_user"].show();
    },
    updateUser() {
      let access_token = localStorage.getItem("access_token");
      let api = "/user/";
      let self = this;
      let data = {
        isActive: self.edit_isActive,
        isAdmin: self.edit_isAdmin,
      };
      this.$http
        .patch(api + self.edit_username, data, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then(() => {
          self.edit_username = undefined;
          self.edit_user_id = undefined;
          self.edit_email = undefined;
          self.edit_isActive = false;
          self.edit_isAdmin = false;
          self.get_user_list();
          self.hideWarning();
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error);
          }
        });
    },
    checkDeleteProbelm(index) {
      let self = this;
      if (index < this.origin_problems_num) {
        self.$refs["warning"].show();
      } else {
        self.items.splice(index, 1);
      }
    },
    deleteProblem(id) {
      let api = "/problem/";
      let access_token = localStorage.getItem("access_token");

      this.$http
        .delete(api + id, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          if (response != undefined) {
            window.location.reload();
          }
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error);
          }
        });
    },
    hideWarning() {
      this.$refs["edit_user"].hide();
    },
    get_user_info() {
      let self = this;
      let api = "/user/me";
      this.access_token = localStorage.getItem("access_token");
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + this.access_token,
          },
        })
        .then((response) => {
          self.userinfo = response.data;
          if (!self.userinfo.isAdmin) {
            self.$router.push({ name: "Home" });
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status == 422) {
              localStorage.clear();
              self.$router.push({ name: "Home" });
            }
          }
        });
    },
    get_user_list() {
      let api = "/user/";
      let access_token = localStorage.getItem("access_token");
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          this.items = response.data;
        });
    },
    toComponent(c_name) {
      let userinfo = this.userinfo;
      this.$router.push({
        name: c_name,
        params: { userinfo },
      });
    },
    exportUser() {
      let users = [];
      this.items.forEach(function (user) {
        users.push({
          username: user.username,
        });
      });
      const anchor = document.createElement("a");
      //console.log(users)
      anchor.href =
        "data:application/json;charset=utf-8," + encodeURIComponent(JSON.stringify(users, null, 2));
      anchor.target = "_blank";
      anchor.download = "Sysjudge-Users.json";
      anchor.click();
    },
  },
};
</script>

<style>
tr {
  vertical-align: middle;
}
</style>